'use strict';

import {
  COOKIE_DURATION_ONE_YEAR,
  COOKIE_NAME_FOR_PREFERRED_LOCALE,
  setCookie
} from '@jspartials/cookie-utils';
import {
  classes,
  addClassToElement,
  hasClassElement
} from '@jspartials/class-list-utils';

const selector = {
  wrapper: '.js-site-selector-wrapper',
  trigger: '.js-site-selector-trigger',
  dropdown: '.js-site-selector-dropdown',
  link: '.js-country-selector-link'
};

document.addEventListener('DOMContentLoaded', function () {
  const wrappers = document.querySelectorAll(selector.wrapper);

  wrappers.forEach((wrapper) => {
    const trigger = wrapper.querySelector(selector.trigger);
    const dropdown = wrapper.querySelector(selector.dropdown);

    if (!trigger || !dropdown) return;

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      const isOpen = !hasClassElement(dropdown, classes.hidden);
      dropdown.classList.toggle(classes.hidden);
      trigger.setAttribute('aria-expanded', String(!isOpen));
    });
  });

  document.addEventListener('click', function (e) {
    document.querySelectorAll(selector.dropdown).forEach((dropdown) => {
      const wrapper = dropdown.closest(selector.wrapper);
      if (wrapper && !wrapper.contains(e.target)) {
        addClassToElement(dropdown, classes.hidden);
        const trigger = wrapper.querySelector(selector.trigger);
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      }
    });
  });

  document.querySelectorAll(selector.link).forEach((link) => {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      const locale = this.dataset.locale;
      const url = this.dataset.url;
      setCookie(
        COOKIE_NAME_FOR_PREFERRED_LOCALE,
        locale,
        COOKIE_DURATION_ONE_YEAR,
        true
      );
      location.href = url;
    });
  });
});
